import React, { useMemo } from "react";
import classNames from "classnames";
import Field from "../_struct/Field";
import FieldI from "../../interfaces/Field";
import { buildHierarchyID, randSufix } from "../../utils/utils";
import { injectWidget } from "../../utils/components";

type Diff<T extends keyof any, U extends keyof any> = ({ [P in T]: P } &
  { [P in U]: never } & { [x: string]: never })[T];
type Overwrite<T, U> = Pick<T, Diff<keyof T, keyof U>> & U;

interface OverwriteProps {
  value?: string;
}

interface Props extends Overwrite<FieldI, OverwriteProps> {}

const widgetName = "Button";

const Button = React.forwardRef(
  (
    { disabled, id, idPrefix, readonly, ui, value, ...restProps }: Props,
    ref: any
  ) => (
    <Field
      id={id}
      printFormRow={false}
      render={({ dataTestId, onClick }) => {
        const handleClick = (
          e: React.MouseEvent<HTMLButtonElement, MouseEvent>
        ) => {
          if (ui?.type === "submit" || ui?.type === "reset") {
            //do not trigget submit/reset from button, they will be triggered on form automatically based on button type
            return;
          }
          onClick(id, e);
        };

        if(disabled){
          return <div></div>
        }
        const randsufix = useMemo(() => randSufix(), []);
        return (
          <button
            className={classNames(
              "btn btn-primary w-100",
              ui?.attributes?.classNames?.widget
            )}
            data-testid={dataTestId}
            disabled={disabled || readonly}
            id={buildHierarchyID(idPrefix, id) + randsufix}
            onClick={handleClick}
            ref={ref}
            style={ui?.attributes?.styles?.widget}
            type={
              (ui?.type as "button" | "reset" | "submit" | undefined) ||
              "button"
            }
          >
            {ui?.attributes?.title}
          </button>
        );
      }}
      ui={injectWidget(ui, widgetName)}
      value={value || ""}
      {...restProps}
    />
  )
);

Button.displayName = widgetName;

export default React.memo(Button);
